export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/defaultSource.js
// module id = 175
// module chunks = 2